import type { ReactNode } from 'react'
import { AuthoredIcon } from '@/components/admin/shared/authored-icon'

/**
 * A source's icon for a table's Source column, falling back to the source
 * name whenever there is no usable icon — none authored at all, or one that
 * fails to load. `AuthoredIcon` owns the emoji-vs-image decision and the
 * failed-src retry, so an authored emoji renders as itself rather than as a
 * broken image, and a later icon change gets a fresh load attempt.
 *
 * Shared by the problems and system-design tables, which render the same
 * column against the same `sourceIcon`/`source` pair.
 *
 * `compact` shrinks the fallback text for the multi-source variant, where
 * several names may have to share one 120px column.
 */
export function SourceIconCell({
  icon,
  name,
  compact = false,
}: {
  icon: string | null | undefined
  name: string
  compact?: boolean
}): ReactNode {
  return (
    <AuthoredIcon
      icon={icon}
      label={name}
      className="rounded align-middle"
      fallbackContent={
        <span
          className={
            compact ? 'text-muted-foreground text-xs' : 'text-muted-foreground'
          }
        >
          {name}
        </span>
      }
    />
  )
}
